// Web build of the composer popover's DOM portal hook.
//
// `react-dom`'s portal is the only way to escape `Modal`-style
// pointer-event capture on react-native-web: the Modal wrapper has
// `pointer-events: auto` and intercepts every tap over its area even
// when the inner backdrop sets `pointerEvents: 'box-none'`. For
// non-dismissable popovers, `Popover.tsx` bypasses Modal and portals a
// single floating layer to `document.body` instead. Only Vite (apps/web)
// resolves this `.web` file; native picks the null-portal sibling
// `domPortal.ts`.

import { createPortal } from 'react-dom';

export const createDomPortal:
  | (<T>(node: T, container: Element | DocumentFragment) => T)
  | null =
  typeof createPortal === 'function'
    ? (createPortal as <T>(node: T, container: Element | DocumentFragment) => T)
    : null;
